import React from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';
import TextField from 'components/TextField/TextField';
//Helpers
import mascaras from '../../../../helpers/mascaras';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

export default function TabelaListaGeradores({ items = [], remover, ficha, permissao, onChangeSequencia }) {
    //Ações da tabela de geradores
    const actions = [
        (rowData) => {
            if (rowData.status == "Programada") {
                return actionsTable.remover(remover);
            }
        }
    ]

    //colocando mascaras nos dados dos items
    items = items.map(value => {
        value.cnpj = mascaras.cpfcnpjMask(value.cnpj);
        return value;
    });
    items = items.filter(value => !value.excluido);
    let headers = [
        { value: "CPF/CNPJ", objectValue: "cnpj" },
        { value: "Identificação", objectValue: "idetificacaoLocalidade" },
        { value: "Modalidade", objectValue: "tbTipoColeta_Descricao" },
        { value: "Endereço", objectValue: "enderecoCompleto" },
        {
            value: "Sequência", objectValue: "sequencia", options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => (
                    <TextField
                        disabled={permissao && permissao == "Editar" ? false : true}
                        value={items[dataIndex].sequencia}
                        onChange={(e) => {
                            onChangeSequencia(dataIndex, e.target.value)
                        }} />
                )
            }
        },
        { value: "Status", objectValue: "status" },

    ]

    if (ficha) {
        return <TabelaListagemFichas headers={headers} items={items} width={"100"} />
    }
    return (
        <TabelaListagem actions={actions} title='Lista de geradores' headers={headers} items={items} options={{ print: false, search: true, pagination: true }} />
    )
}